import * as $ from 'jquery';

export default class RowHeader {
  static NAMESPACE = 'axel-row-header';

  public opts;
  public label;
  private renderer;
  private data;

  constructor(renderer, opts = {}) {
    this.opts = opts;
    this.renderer = renderer;
    this.label = 'row-header';
  }

  static namespace = (evtName) => evtName + '.' + RowHeader.NAMESPACE;

  initialize(renderer, containerEl) {
    const superRowBuilder = renderer.buildRow();

    function tableRowHeaderLayout(rowIndex) {
      const thEl = document.createElement('th');
      thEl.textContent = rowIndex;
      return thEl;
    }

    renderer.buildRow(function (tree, rowKey, i, ...args) {
      const rowIndex = i + 1;
      const rowEl = superRowBuilder.apply(null, [tree, rowKey, i, ...args]);

      rowEl.insertBefore(tableRowHeaderLayout(rowIndex), rowEl.firstChild);
      return rowEl;
    });

    return renderer;
  }

  buildHeader(theadEl, containerEl, opts: any = {}) {
    const headerRowEl = theadEl.querySelector('tr');
    const paddingCellEl = document.createElement('th');

    paddingCellEl.className = 'js-axel-ignore';
    headerRowEl.insertBefore(paddingCellEl, headerRowEl.firstChild);

    return theadEl;
  }

  buildTable(tableEl, containerEl, opts: any = {}) {
    // add plugin class
    $(tableEl).addClass(RowHeader.NAMESPACE);

    return tableEl;
  }
}
